/*
 * @FileName       : action.ts
 * @Version        : 1.0
 * @DateOfCreation : 04/17/2020
 * @Author         : $u^^!t @ FFF Enterprises
 * @Dependencies   : N/A
 * @Description    : Action constants to store all the constants belongs to actions.
 *
 * Copyright (c) 2020, FFF Enterprises. All rights reserved.
 */

export const UI = {
	SHOW_LOADER: 'SHOW_LOADER',
	SET_API_ERROR: 'SET_API_ERROR',
	PRELOAD_DATA: 'PRELOAD_DATA',
	PRELOAD_DATA_SUCCESS: 'PRELOAD_DATA_SUCCESS',
	SET_SNACKBAR_OPEN: 'SET_SNACKBAR_OPEN',
	SET_SNACKBAR_MESSAGE: 'SET_SNACKBAR_MESSAGE',
};

export const ORDER = {
	CREATE_ORDER: 'CREATE_ORDER',
	CREATE_PREORDER : 'CREATE_PREORDER',
	GET_ORDER_DETAILS: 'GET_ORDER_DETAILS',
	SET_ORDER_DETAILS: 'SET_ORDER_DETAILS',
	SET_ORDER_QUANTITY: 'SET_ORDER_QUANTITY',

	SET_ORDER_WALL_UNIT_QUANTITY: 'SET_ORDER_WALL_UNIT_QUANTITY',
	SET_ALL_ORDER_LINE_ITEMS: 'SET_ALL_ORDER_LINE_ITEMS',

	 SET_ODR_QUANTITY: 'SET_ODR_QUANTITY',
  SET_ODR_POUCH_QUANTITY: 'SET_ODR_POUCH_QUANTITY',
  SET_NARCAN_QUANTITY: 'SET_NARCAN_QUANTITY',
  SET_NARCAN_CHECKED: 'SET_NARCAN_CHECKED',
  SET_AUTO_CALC_NARCAN_CHECKED: 'SET_AUTO_CALC_NARCAN_CHECKED',

	GET_TAX_RATE: 'GET_TAX_RATE',
	SET_TAX_RATE: 'SET_TAX_RATE',
	SET_TAX_RATE_LOADED: 'SET_TAX_RATE_LOADED',
	CLEAR_TAX_RATE: 'CLEAR_TAX_RATE',
	SHOW_TAX_LOADER: 'SHOW_TAX_LOADER',
	VALIDATE_ADDRESS: 'VALIDATE_ADDRESS',
	SET_VALIDATED_ADDRESSES: 'SET_VALIDATED_ADDRESSES',
	VALIDATE_ADDRESS_LIST: 'VALIDATE_ADDRESS_LIST',
	SET_VALIDATED_TAX_RESULTS: 'SET_VALIDATED_TAX_RESULTS',
	GET_PRODUCT: 'GET_PRODUCT',
	SET_PRODUCT: 'SET_PRODUCT',
	GET_CC_PAYMENT_TOKEN: 'GET_CC_PAYMENT_TOKEN',
	SET_TOKEN: 'SET_TOKEN',
	SET_PAYMENT_INPUTS: 'SET_PAYMENT_INPUTS',
	CLEAR_PAYMENT_INPUTS: 'CLEAR_PAYMENT_INPUTS',
	SET_SHIPPING_LIST: 'SET_SHIPPING_LIST',
	SET_SHIP_FROM_WAREHOUSE_MAP: 'SET_SHIP_FROM_WAREHOUSE_MAP'
};

export const CAPTCHA = {
	SET_CAPTCHA_TOKEN: 'SET_CAPTCHA_TOKEN',
	SET_IS_CAPTCHA_VALID: 'SET_IS_CAPTCHA_VALID',
};


// export const UI = {
//   SHOW_LOADER : 'SHOW_LOADER',
//   SET_API_ERROR: 'SET_API_ERROR',
//   PRELOAD_DATA: 'PRELOAD_DATA',
//   PRELOAD_DATA_SUCCESS: 'PRELOAD_DATA_SUCCESS',
//   SET_SNACKBAR_OPEN: 'SET_SNACKBAR_OPEN',
// 	SET_SNACKBAR_MESSAGE: 'SET_SNACKBAR_MESSAGE',
// };

// export const ORDER = {
//   CREATE_ORDER : 'CREATE_ORDER',
//   CREATE_PREORDER : 'CREATE_PREORDER',
//   GET_ORDER_DETAILS : 'GET_ORDER_DETAILS',
//   SET_ORDER_DETAILS: 'SET_ORDER_DETAILS',
//   SET_ODR_QUANTITY: 'SET_ODR_QUANTITY',
//   SET_ODR_POUCH_QUANTITY: 'SET_ODR_POUCH_QUANTITY',
//   SET_NARCAN_QUANTITY: 'SET_NARCAN_QUANTITY',
//   SET_NARCAN_CHECKED: 'SET_NARCAN_CHECKED',
//   SET_AUTO_CALC_NARCAN_CHECKED: 'SET_AUTO_CALC_NARCAN_CHECKED',
//   GET_TAX_RATE: 'GET_TAX_RATE',
//   SET_TAX_RATE: 'SET_TAX_RATE',
//   SET_TAX_RATE_LOADED: 'SET_TAX_RATE_LOADED',
//   CLEAR_TAX_RATE: 'CLEAR_TAX_RATE',
//   SHOW_TAX_LOADER : 'SHOW_TAX_LOADER',
//   VALIDATE_ADDRESS: 'VALIDATE_ADDRESS',
//   SET_VALIDATED_ADDRESSES: 'SET_VALIDATED_ADDRESSES',
//   GET_PRODUCT : 'GET_PRODUCT',
//   SET_PRODUCT: 'SET_PRODUCT',
//   GET_CC_PAYMENT_TOKEN: 'GET_CC_PAYMENT_TOKEN',
//   SET_TOKEN: 'SET_TOKEN',
//   SET_PAYMENT_INPUTS: 'SET_PAYMENT_INPUTS',
//   CLEAR_PAYMENT_INPUTS: 'CLEAR_PAYMENT_INPUTS'
// };




